import { alias, custom, deserialize, serializable, SKIP } from 'serializr';
import { ProvisioningProfile } from './provisioning-profile.model';
import { AgentDevice } from './agent-device.model';
import { Base } from './base.model';
import { PageObject } from './page-object.model';

export class ProvisioningProfileDevice extends Base implements PageObject {
  @serializable
  public provisioningProfileId: number;
  @serializable
  public agentDeviceId: number;
  @serializable
  public deviceUDId: string;
  @serializable(
    custom(
      (v) => v,
      (v) => {
        if (v) return new ProvisioningProfile().deserialize(v);
      },
    ),
  )
  public provisioningProfile: ProvisioningProfile;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public agentDevice: AgentDevice;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ProvisioningProfileDevice, input));
  }
}
